/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_Q7Inputs */

const en_fc_home_faq_q7 = /** @type {(inputs: Fc_Home_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is FilmCraft safe and legit?`)
};

/**
* | output |
* | --- |
* | "Is FilmCraft safe and legit?" |
*
* @param {Fc_Home_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_q7 = /** @type {((inputs?: Fc_Home_Faq_Q7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_Q7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_q7(inputs)
});
export { fc_home_faq_q7 as "fc.home.faq.q7" }